import React from 'react';
import ShowLoader from '../../hoc/ShowLoader/ShowLoader';
import UserAPIController from '../../webServices/UserAPIController';
import { connect } from "react-redux";
import * as actionCreators from '../../store/actions/mainLayoutActions';

import classes from './UpdateJobProfile.module.css';
import { Link } from 'react-router-dom';
import RouteEndPoints from '../../utilities/RouteEndPoints';

class UpdateJobProfile extends React.Component {
    state = {
        callInProgress: false,
        callSuccess: false,
        callFailed: false,
        accountNotPresent: false,
        message: ''
    }

    onUpdateJobProfileClicked = () => {
        this.setState({ callInProgress: true, callSuccess: false, callFailed: false });

        UserAPIController.updateJobProfile()
            .then(response => {
                // console.log('Response -> ', response)
                setTimeout(() => {
                    this.setState({ callSuccess: true, callInProgress: false, callFailed: false, accountNotPresent: false });
                    window.location.replace(response.result.url);
                }, 3000);
            })
            .catch(err => {
                console.log('Update Job Profile Error => ', err);
                let accountStatus = false, message = '';
                if (err.error.status === 400) {
                    // this.setState({ accountNotPresent: true,  });
                    message = err.error.message;
                    accountStatus = true;
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    accountStatus = false;
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 500) {
                    accountStatus = false;
                    this.props.onFailureDialogShow('Something went wrong. Please try again or contact admin.', 'OKAY');
                }
                this.setState({ callSuccess: false, callInProgress: false, callFailed: true, accountNotPresent: accountStatus, message: message });
            });
    }

    componentDidMount() {
        this.props.setupProgramDetailsTopbar(true, false, false);
        this.onUpdateJobProfileClicked();
    }

    render() {
        return (
            <div className={classes.UpdateJobProfilePageContainer}>
                {
                    this.state.callInProgress === true && this.state.callFailed === false && this.state.callSuccess === false
                        ? <>
                            <p className={classes.Message}>Please wait. <br /> We are collecting all the details. </p>
                            <div className={classes.LoaderContainer}>
                                <ShowLoader isLoading={true} />
                            </div>
                        </>
                        : this.state.callSuccess === true && this.state.callInProgress === false && this.state.callFailed === false
                            ? <>
                                <p className={classes.Message}>Please wait. <br /> We are redirecting you. </p>
                                <div className={classes.LoaderContainer}>
                                    <ShowLoader isLoading={true} />
                                </div>
                            </>
                            : this.state.callInProgress === false && this.state.callFailed === true
                                ? this.state.accountNotPresent === true
                                    ? <p className={classes.Message}>{this.state.message}<br />Please contact us
                                    <Link to={RouteEndPoints.CONTACT_US_PAGE} className={classes.Link}> here</Link>
                                    </p>
                                    : <p className={classes.Message}>Something went wrong. <br /> Please refresh the page and try again. </p>
                                : null
                }
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        activeProgramBatchCode: state.activeProgramBatchCode,
        enrolledProgramsList: state.enrolledProgramsList,
        showSuccessDialog: state.showSuccessDialog,
        successDialogMessage: state.successDialogMessage,
        successDialogButtonLabel: state.successDialogButtonLabel,
        showFailureDialog: state.showFailureDialog,
        failureDialogMessage: state.failureDialogMessage,
        failureDialogButtonLabel: state.failureDialogButtonLabel,
        somethingWentWrong: state.somethingWentWrong,
        notFound: state.notFound,
        unauthorized: state.unauthorized,
    }
}

const mapDisptachToProps = dispatch => {
    return {
        setupProgramDetailsTopbar: (showTopbar, showProgramProgress, showModuleProgress) => dispatch(actionCreators.setupProgramDetailsTopbar(showTopbar, showProgramProgress, showModuleProgress)),

        onFailureDialogShow: (msg, btnLabel) => dispatch(actionCreators.onFailureDialogShow(msg, btnLabel)),
        onFailureDialogHide: () => dispatch(actionCreators.onFailureDialogHide()),
        onSuccessDialogShow: (msg, btnLabel) => dispatch(actionCreators.onSuccessDialogShow(msg, btnLabel)),
        onSuccessDialogHide: () => dispatch(actionCreators.onSuccessDialogHide()),

        redirectToUnauthorized: () => dispatch(actionCreators.redirectToUnauthorized()),
        redirectToNotFound: () => dispatch(actionCreators.redirectToNotFound()),
        redirectToServerError: () => dispatch(actionCreators.redirectToServerError()),
        showSessionExpiredDialog: (show) => dispatch(actionCreators.showSessionExpiredDialog(show))
    }
}

export default connect(mapStateToProps, mapDisptachToProps)(UpdateJobProfile);